import actionCreatorFactory from 'typescript-fsa';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('endpointOperationSubdiv');

const launchEndpointSubdiv = actionCreator.async<
  {
    koujiBangou: string;
    operationKey: string;
  }, // started: parameter type
  {
    success: boolean;
    message: string;
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('LAUNCH_ENDPOINT');

const stopEndpointSubdiv = actionCreator.async<
  {
    koujiBangou: string;
    operationKey: string;
  }, // started: parameter type
  {
    success: boolean;
    message: string;
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('STOP_ENDPOINT');

export {
  launchEndpointSubdiv,
  stopEndpointSubdiv
};



// WEBPACK FOOTER //
// ./src/redux/modules/endpointOperationSubdiv/actions.ts